import { makeStyles } from '@material-ui/core/styles';

export const useSequencesAttemptsFormStyles = makeStyles(theme => ({
  buttonContainer: {
    margin: theme.spacing(2, 3, 3, 3)
  }
}));
